export enum FirebaseAuthErrorCode {
    InvalidPhoneNumber = 'auth/invalid-phone-number',
    MissingPhoneNumber = 'auth/missing-phone-number',
    InvalidOtp = 'auth/invalid-verification-code',
    CodeExpired = 'auth/code-expired'
}

export enum UIMessages {
    SMKConfirm = "તમારી પાસે SMK નંબર છે?",
    NonSMKNotAllowed = "Only Bhakt with SMK number is allowed to fill form",
    CantEdit = "Form is already filled for this user. Editing not allowed",
    SMKConfirmYes = "હા, છે",
    SMKConfirmNo = "ના, નથી",
    NOBhaktId = "Bhakt Id not found please try again"
}

export enum Form {
    TODAY = "today",
    OTHER = "other"
}


export enum Popup {
    EmailList = 1,
    FamilyList = 2,
    BhaktList = 3
}


export enum Payment {
    NoPayment = 1,
    PayWoPaylater = 2,
    PayWPaylater = 3,
    PayWPaylaterForeginOnly = 4
}

export const Gateway = {
  Easebuzz: 'easebuzz',
  Razorpay: 'razorpay',
} as const;



export enum FormType {
    Generic = 1,
    RASOI = 2,
    CHANDAN = 3,
    DHOTIYA = 4,
    GenericRestrictedEntry = 5,
    ThalBhet = 6,
    BhajanYag = 7,
    Yagna = 8,
    /** Prasad booking — family rasoi uses PrasadVitran/SearchPavti (one BhaktId → full family). */
    PrasadBooking = 9,
}


export enum FormTypeList {
    Generic = 'Generic',
    RASOI = 'રસોઈ',
    CHANDAN = 'ચંદનના વાઘા',
    DHOTIYA = 'ધોતિયા',
    GenericRestrictedEntry = 'Generic Restricted Entry',
    ThalBhet = 'THAL-BHET',
    BhajanYag = 'Bhajan Yag',
    Yagna = 'Yagna',
    PrasadBooking = 'Prasad Booking',
}


export enum Mode {
    QUESTION = 1,
    RULE = 2,
    EQUATION = 3
}